import React from "react"
import { Button, Col, Row } from "react-bootstrap"
import BootstrapTable, { ColumnDescription } from "react-bootstrap-table-next"
import filterFactory from "react-bootstrap-table2-filter"
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit"
import { useTranslation } from "react-i18next"
import { DispatchModel } from "../../api/dispatch.api"
import { SearchBar } from "../../components/Tables/Columns"

function DispatchTable({
    dispatch,
    handleOnSelect,
    handleOnSelectAll,
    handleBtnClick,
    selectedRows
}: {
    dispatch: DispatchModel[]
    handleOnSelect: Function
    handleOnSelectAll: any
    handleBtnClick: Function
    selectedRows: any
}) {
    const { t } = useTranslation()
    const onSelect = (row: any, isSelect: any) => {
        handleOnSelect(row, isSelect)
    }
    const selectRow: any = {
        mode: "checkbox",
        clickToSelect: true,
        onSelect: onSelect,
        onSelectAll: handleOnSelectAll,
        selectColumnPosition: "right"
    }

    const printMenifest = () => {
        handleBtnClick()
    }
    const columns = [
        {
            dataField: "id",
            text: t("#")
        },
        {
            text: t("Parcel_ID"),
            dataField: "uuid",
            classes: "highlighted-text"
        },
        {
            text: t("AWB"),
            dataField: "awb"
        },
        {
            text: t("Amount"),
            dataField: "amount"
        }
    ]

    const { ExportCSVButton } = CSVExport

    return (
        <div className="table-responsive">
            {columns && (
                <ToolkitProvider
                    keyField="uuid"
                    data={dispatch}
                    columns={columns as ColumnDescription<any, any>[]}
                    search={{ searchFormatted: true }}
                    exportCSV={{
                        fileName: "dispatchTable.csv",
                        noAutoBOM: false,
                        exportAll: false,
                        onlyExportFiltered: true
                    }}>
                    {(props) => (
                        <div className="table-container my-4">
                            <Row className="search mx-3  suites-search">
                                <Col xs={12} sm={6} md={6} lg={6}></Col>
                                <Col xs={12} sm={12} md={12} lg={6} className="px-4 search-col">
                                    <SearchBar {...props.searchProps} />
                                    <ExportCSVButton
                                        {...props.csvProps}
                                        className=" dispatchExportButton d-none">
                                        Export
                                    </ExportCSVButton>
                                </Col>
                            </Row>
                            {selectedRows && selectedRows.length > 0 && (
                                <Row className="mt-4 mx-1">
                                    <Col xs={12} sm={12} md={12} lg={12} className="text-align-end ">
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            className="w-15"
                                            onClick={() => printMenifest()}>
                                            {t("Print_Manifest")}
                                        </Button>
                                    </Col>
                                </Row>
                            )}
                            <Row className="table-data my-3">
                                <Col>
                                    <BootstrapTable
                                        {...props.baseProps}
                                        wrapperClasses="table-wrapper my-3 "
                                        headerClasses="header-class"
                                        bordered={false}
                                        noDataIndication={t("No_Record")}
                                        filter={filterFactory()}
                                        rowClasses="custom-table-row"
                                        condensed={true}
                                        selectRow={selectRow}
                                    />
                                </Col>
                            </Row>
                            {selectedRows && selectedRows.length > 0 && (
                                <Row className="mt-4 mx-1">
                                    <Col xs={12} sm={12} md={12} lg={12} className="text-align-end ">
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            className="w-15"
                                            onClick={() => printMenifest()}>
                                            {t("Print_Manifest")}
                                        </Button>
                                    </Col>
                                </Row>
                            )}
                        </div>
                    )}
                </ToolkitProvider>
            )}
        </div>
    )
}

export default DispatchTable
